<!-- begin:: Header Topbar -->
<div class="kt-header__topbar kt-grid__item">
	<!--begin: Developer tools -->
	<rek-dev-tools *ngIf="isGakkoDev"></rek-dev-tools>
	<!--end: Developer tools -->

	<!--begin: Language bar -->
	<kt-language-selector></kt-language-selector>
	<!--end: Language bar -->

	<!--begin: Login button -->
	<div *ngIf="isEnrollmentActive && !isAuthenticated" placement="bottom" class="kt-header__topbar-item">
		<div class="kt-header__topbar-wrapper">
			<a [routerLink]='AuthPaths.Login' [queryParams]="{ returnUrl: AppPaths.App.Dashboard.Home.StringPath}"
				[state]='{ local: true }' [ngbTooltip]="'SHARED.LOGIN.LOG-IN' | translate" class="kt-header__topbar-icon">
				<i class="fa fa-key"></i>
			</a>
		</div>
	</div>
	<!--end: Login button -->

	<!--begin: Register button -->
	<div *ngIf="isEnrollmentActive && !isAuthenticated" placement="bottom" class="kt-header__topbar-item">
		<div class="kt-header__topbar-wrapper">
			<a [routerLink]='AuthPaths.Register' class="rek-topmenu-right__link kt-header__topbar-icon">
				<span class="rek-topmenu-right__text">
					{{ "SHARED.REGISTER" | translate }}
				</span>
			</a>
		</div>
	</div>
	<!--end: Register button -->

	<!--begin: Logout button -->
	<div *ngIf="isAuthenticated" placement="bottom" class="kt-header__topbar-item">
		<div class="kt-header__topbar-wrapper">
			<a [routerLink]='AuthPaths.LogOut' [state]='{ local: true }' class="rek-logout kt-header__topbar-icon">
				<i class="rek-logout__icon fa fa-power-off"></i>
				<div class="rek-logout__caption">{{ 'SHARED.LOGOUT.LOGOUT-ICON-CAPTION' | translate }}</div>
			</a>
		</div>
	</div>
	<!--end: Logout button -->

</div>
<!-- end:: Header Topbar -->